import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultResponse } from '@reflact/reflactportal';
import { firstValueFrom } from 'rxjs';

interface OpenAiStatusResponse extends DefaultResponse {
    configured: boolean;
}

interface FalStatusResponse extends DefaultResponse {
    configured: boolean;
    /** Ohne gespeicherten Key greift ersatzweise die Umgebungsvariable FAL_KEY des Servers. */
    envFallback: boolean;
}

/** Superadmin-only settings (siehe /admin/settings) — OpenAI-Key und fal.ai-Key für die
 * Kachel-Bildgenerierung (server/src/settings/*). */
@Injectable({
    providedIn: 'root'
})
export class SettingsService {

    constructor(private http: HttpClient) { }

    public async getOpenAiStatus(): Promise<boolean> {
        const res = await firstValueFrom(this.http.get<OpenAiStatusResponse>("/api/settings/openai"));
        return res.status == "ok" && res.configured;
    }

    public async setOpenAiApiKey(apiKey: string): Promise<DefaultResponse> {
        return await firstValueFrom(this.http.post<DefaultResponse>("/api/settings/openai", { apiKey }));
    }

    public async clearOpenAiApiKey(): Promise<DefaultResponse> {
        return await firstValueFrom(this.http.post<DefaultResponse>("/api/settings/openai/clear", {}));
    }

    public async getFalStatus(): Promise<{ configured: boolean; envFallback: boolean }> {
        const res = await firstValueFrom(this.http.get<FalStatusResponse>("/api/settings/fal"));
        return { configured: res.status == "ok" && res.configured, envFallback: res.status == "ok" && res.envFallback };
    }

    public async setFalApiKey(apiKey: string): Promise<DefaultResponse> {
        return await firstValueFrom(this.http.post<DefaultResponse>("/api/settings/fal", { apiKey }));
    }

    public async clearFalApiKey(): Promise<DefaultResponse> {
        return await firstValueFrom(this.http.post<DefaultResponse>("/api/settings/fal/clear", {}));
    }

}
